import React, { useEffect, useState } from 'react'
import { education, employmentType, experienceLevel, jobFuntion, team, workplaceType } from '../../components/JobInputData';



const AddJob = ({ inputs, setInputs }: any) => {
	// @ts-ignore  
	const user = JSON.parse(localStorage.getItem("user"));
	const [comment, setComment] = useState("");

	// const uid = new ShortUniqueId();

	useEffect(() => {

		setInputs((prevState: any) => {
			return ({
				...prevState,
				jobProfile: comment
			});
		});

	}, [comment, setInputs]);


	useEffect(() => {
		setInputs((prevState: any) => {
			return ({
				...prevState,
				userId: user?._id
			});
		});
	}, [inputs.userId, setInputs, user?._id]);


	const handleOnChange = (input: any, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};



	return (
		<div  >
			<div>
				<div className='AddJob_main_container_input'>
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Job Title</h6>

						{/* <AutoComplete setComment={setComment} inputs={inputs} /> */}
						<input type="text"
							className='AddJobinput' style={{ marginBottom: "15px", }}
							value={inputs?.jobTitle}
							onChange={(e) => handleOnChange("jobProfile", e.target.value)}
							placeholder='Job Title' />
					</div>
				</div>
				<div className='AddJob_main_container_input_two'>
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'> Job Function </h6>
						<select className="round"
							value={inputs?.jobFunction}
							onChange={(e) => handleOnChange("jobFunction", e.target.value)}>
							<option className='employment-option'>Select Job Function...</option>
							{jobFuntion?.map((item: any, i: any) => (
								<option key={i} value={item}  >
									{item}
								</option>
							))}
						</select>
					</div>
					<div style={{ margin: '20px' }} />
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Team</h6>
						<select className="round"
							value={inputs?.team}
							onChange={(e) => handleOnChange("team", e.target.value)}>
							<option className='employment-option'>Select Team</option>
							{team?.map((item: any, i: any) => (
								<option key={i} value={item}>
									{item}
								</option>
							))}
						</select>
					</div>

				</div>
				<div className='AddJob_main_container_input_two'>
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Employment Type</h6>
						<select className="round"
							value={inputs?.employmentType}
							onChange={(e) => handleOnChange("employmentType", e.target.value)}>
							<option className='employment-option'>Select Employment Type</option>
							{employmentType?.map((item: any, i: any) => (
								<option key={i} value={item}>
									{item}
								</option>
							))}
						</select>
					</div>
					<div style={{ margin: '20px' }} />
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Experience Level</h6>
						<select className="round"
							value={inputs?.experienceLevel}
							onChange={(e) => handleOnChange("experienceLevel", e.target.value)}>
							<option className='employment-option'>Select Experience Level</option>
							{experienceLevel?.map((item: any, i: any) => (
								<option key={i} value={item}  >
									{item}
								</option>
							))}
						</select>
					</div>
				</div>

				<div className='AddJob_main_container_input_two'>
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'> Education </h6>
						<select className="round"
							value={inputs?.education}
							onChange={(e) => handleOnChange("education", e.target.value)}>
							<option className='employment-option'>Select education</option>
							{education?.map((item: any, i: any) => (
								<option key={i} value={item}  >
									{item}
								</option>
							))}
						</select>
					</div>
					<div style={{ margin: '20px' }} />
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Workplace Type</h6>
						<select className="round"
							value={inputs.workplaceType}
							onChange={(e) => handleOnChange("workplaceType", e.target.value)}>
							<option className='employment-option'>Select Workplace Type</option>
							{workplaceType?.map((item: any, i: any) => (
								<option key={i} value={item}>
									{item}
								</option>
							))}
						</select>
					</div>

				</div>

				<div className='AddJob_main_container_input_Checkbox'>
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'> Job Location</h6>
						<input
							className="AddJobinput"
							type="text"
							value={inputs?.jobLocation}
							onChange={(e) => handleOnChange("jobLocation", e.target.value)}
							placeholder=' Enter Job Location '
						/>
					</div>

				</div>
			</div>
		</div >
	)
}

export default AddJob

